import React from "react";
import PropTypes from "prop-types";
import { Box, Typography, Button, Stack } from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

const C1EmptyState = ({
  icon,
  title,
  description,
  actionLabel,
  onAction,
  severity = "info",
}) => {
  const resolvedIcon =
    icon && React.isValidElement(icon) ? icon : <InfoOutlinedIcon />;

  return (
    <Box
      sx={{
        p: 3,
        borderRadius: 3,
        border: "1px solid",
        borderColor: `${severity}.light`,
        bgcolor: "background.paper",
      }}
    >
      <Stack direction="row" spacing={2} alignItems="flex-start">
        <Box
          sx={{
            width: 48,
            height: 48,
            borderRadius: "50%",
            bgcolor: `${severity}.light`,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexShrink: 0,
          }}
        >
          {React.cloneElement(resolvedIcon, {
            sx: {
              color: `${severity}.main`,
              fontSize: 24,
              ...(resolvedIcon.props?.sx || {}),
            },
          })}
        </Box>

        <Box flex={1}>
          <Typography variant="h6" color="text.primary" gutterBottom>
            {title}
          </Typography>

          {description ? (
            <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
              {description}
            </Typography>
          ) : null}

          {actionLabel && onAction && (
            <Button
              variant="contained"
              color={severity}
              size="large"
              onClick={onAction}
            >
              {actionLabel}
            </Button>
          )}
        </Box>
      </Stack>
    </Box>
  );
};

C1EmptyState.propTypes = {
  icon: PropTypes.node,
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  actionLabel: PropTypes.string,
  onAction: PropTypes.func,
  severity: PropTypes.oneOf(["info", "success", "warning", "error"]),
};

export default C1EmptyState;
